import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./lib/debug";
import "./styles/tokens.css";
import "./styles/global.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
